import { Skeleton } from '@/components/shadcn/skeleton'

export function SupportPanelLoading() {
  const boxes = Array.from({ length: 10 }, (_, i) => i)
  return (
    <div className="h-full pt-5">
      <div className="flex h-full flex-col gap-y-4 overflow-hidden">
        {boxes.map((box) => (
          <Skeleton key={box} className="h-20 w-full" />
        ))}
      </div>
    </div>
  )
}
